import React, { useState, useEffect } from 'react'
import {
  IoLogoTiktok,
  IoLogoInstagram,
  IoLogoWhatsapp,
  IoShareSocial,
  IoLocationOutline,
  IoMail,
} from 'react-icons/io5'
import { RiPhoneFill } from 'react-icons/ri'
import { FaFacebookF, FaCar } from 'react-icons/fa'
import SocialLink from '../elements/SocialLink'

const Social = ({
  phoneNumber,
  phoneText,
  whatsappNumber,
  facebookUrl,
  wazeUrl,
  wazeText,
  locationUrl,
  instagramUsername,
  tiktokUsername,
  email,
  shareButton = false, // Default is false
  type,
}) => {
  // ✅ Define functions first to avoid reference errors
  const openInNewTab = (url) => {
    window.open(url, '_blank')
  }

  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`
  }

  const handleWhatsappClick = (whatsappNumber) => {
    const phoneNumber = whatsappNumber.replace(/\D/g, '')
    openInNewTab(`https://wa.me/${phoneNumber}`)
  }

  const handleFacebookClick = (facebookUrl) => {
    openInNewTab(facebookUrl)
  }

  const handleInstagramClick = (instagramUsername) => {
    openInNewTab(`https://www.instagram.com/${instagramUsername}`)
  }

  const handleTiktokClick = (tiktokUsername) => {
    openInNewTab(`https://www.tiktok.com/@${tiktokUsername}`)
  }

  const handleWazeClick = (wazeUrl) => {
    openInNewTab(wazeUrl)
  }

  const handleLocationClick = (locationUrl) => {
    openInNewTab(locationUrl)
  }

  const handleShareUrl = () => {
    const currentUrl = window.location.href

    if (navigator.share) {
      navigator
        .share({
          title: 'Digicard',
          text: 'כרטיס ביקור דיגיטלי',
          url: currentUrl,
        })
        .then(() => console.log('URL shared successfully'))
        .catch((error) => console.error('Error sharing URL:', error))
    } else {
      openInNewTab(currentUrl)
    }
  }

  const handleEmailClick = (email) => {
    const subject = encodeURIComponent('Digicard - כרטיס ביקור דיגיטלי')
    const body = encodeURIComponent('שלום,\n\nרציתי ליצור איתך קשר לגבי כרטיס הביקור הדיגיטלי שלך.')
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`
    window.location.href = mailtoLink
  }

  // ✅ Now define social links after functions are initialized
  const socialLinksData = [
    { text: phoneText, icon: RiPhoneFill, action: () => handlePhoneClick(phoneNumber), data: phoneNumber },
    { text: 'ווטסאפ', icon: IoLogoWhatsapp, action: () => handleWhatsappClick(whatsappNumber), data: whatsappNumber },
    { text: 'פייסבוק', icon: FaFacebookF, action: () => handleFacebookClick(facebookUrl), data: facebookUrl },
    { text: wazeText, icon: FaCar, action: () => handleWazeClick(wazeUrl), data: wazeUrl },
    { text: 'מיקום', icon: IoLocationOutline, action: () => handleLocationClick(locationUrl), data: locationUrl },
    {
      text: 'אינסטגרם',
      icon: IoLogoInstagram,
      action: () => handleInstagramClick(instagramUsername),
      data: instagramUsername,
    },
    { text: 'טיקטוק', icon: IoLogoTiktok, action: () => handleTiktokClick(tiktokUsername), data: tiktokUsername },
    { text: 'אימייל', icon: IoMail, action: () => handleEmailClick(email), data: email }, // ✅ New Email Option
  ]

  // ✅ Add share button conditionally
  if (shareButton) {
    socialLinksData.push({ text: 'שיתוף', icon: IoShareSocial, action: handleShareUrl, data: true })
  }

  // ✅ Filter out empty values
  const filteredSocialLinks = socialLinksData.filter(
    (link) => link.data !== null && link.data !== undefined && link.data !== '',
  )

  const renderSocialLinks = filteredSocialLinks.map((link, index) => (
    <SocialLink key={index} text={link.text} icon={link.icon} onClickAction={link.action} type={type} />
  ))

  const [isLargeScreen, setIsLargeScreen] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth > 768)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    return () => {
      window.removeEventListener('resize', checkScreenSize)
    }
  }, [])

  return (
    <div className="mt-4">
      <div data-aos="fade-down" data-aos-easing="ease-in-out">
        {isLargeScreen ? (
          <div className="w-[99%] flex mx-auto justify-around">{renderSocialLinks}</div>
        ) : (
          <div className="flex flex-col">
            <div className="w-[99%] flex mx-auto justify-around">{renderSocialLinks.slice(0, 3)}</div>
            <div className="w-[99%] flex mx-auto justify-around">{renderSocialLinks.slice(3)}</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Social
